import {
  AccessorFnColumnDef,
  CellContext,
  Header,
} from '@tanstack/react-table';

export const createCellContext = <TData>(
  header: Header<TData, unknown>,
  data: TData,
  rowIndex: number,
): CellContext<TData, unknown> & { isAggregateRow?: boolean } => {
  const accessorFn = (
    header.column.columnDef as AccessorFnColumnDef<TData, string>
  ).accessorFn;
  const value = accessorFn ? accessorFn(data, rowIndex) : '';

  return {
    getValue: () => value,
    isAggregateRow: true,
    row: {
      index: rowIndex,
      original: data,
    },
  } as CellContext<TData, unknown> & { isAggregateRow?: boolean };
};
